import { toast } from "@/components/ui/use-toast";

export type HubEntityType = "note" | "moment" | "swap";

const getEntityLabel = (entityType: HubEntityType) => {
  switch (entityType) {
    case "note":
      return "Note";
    case "moment":
      return "Moment";
    case "swap":
      return "Swap";
  }
};

export const hubToast = {
  sent: (entityType: HubEntityType) => {
    const label = getEntityLabel(entityType);
    toast({
      title: `${label} sent`,
      description: `Your ${label.toLowerCase()} was successfully sent to teen`,
    });
  },

  deleted: (entityType: HubEntityType) => {
    const label = getEntityLabel(entityType);
    toast({
      title: `${label} deleted`,
      description: `Your ${label.toLowerCase()} was successfully deleted`,
    });
  },

  scheduleChanged: (entityType: HubEntityType) => {
    const label = getEntityLabel(entityType);
    toast({
      title: "Changed schedule",
      description: `${label} schedule was successfully changed`,
    });
  },

  scheduled: (entityType: HubEntityType) => {
    const label = getEntityLabel(entityType);
    toast({
      title: `${label} scheduled`,
      description: `Your ${label.toLowerCase()} has been scheduled`,
    });
  },

  error: (message: string) => {
    toast({
      title: "Error",
      description: message,
      variant: "destructive",
    });
  },
};
